<template>
  <md-dialog :md-active.sync="active" @md-closed="close">
    <md-dialog-content>
      <h3 class="icon-area">
        <gl-icon-warning />
      </h3>
      {{ message }}
    </md-dialog-content>
    <md-dialog-actions>
      <gl-button @click="close">Close</gl-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { Subject } from 'rxjs'

/**
 * 想定外エラーをユーザーに伝えるダイアログ
 */
export default {
  data() {
    const subject = new Subject()
    return {
      active: false,
      afterClosed: subject,
      afterClosed$: subject.asObservable(),
      message: undefined,
    }
  },
  methods: {
    open(message) {
      this.message = message
      this.active = true

      return this.afterClosed$
    },
    close(arg = undefined) {
      this.active = false
      this.afterClosed.next(arg)
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-area {
  color: var(--color-warn);
  text-align: center;
}
</style>
